(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casa-facets"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-casa-facets-open]').forEach(function (button) {
      if (button.getAttribute('data-bound') === 'true') return;
      button.setAttribute('data-bound', 'true');
      button.addEventListener('click', function () {
        var dialog = document.querySelector('[data-casa-facets-dialog]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        dialog.showModal();
        button.setAttribute('aria-expanded', 'true');
      });
    });

    document.querySelectorAll('[data-casa-facets-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        var dialog = button.closest('dialog');
        if (dialog) dialog.close();
      });
    });

    document.querySelectorAll('[data-casa-facets-dialog]').forEach(function (dialog) {
      dialog.addEventListener('close', function () {
        document.querySelectorAll('[data-casa-facets-open]').forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casa-sort"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-casa-sort]').forEach(function (select) {
      if (select.getAttribute('data-bound') === 'true') return;
      select.setAttribute('data-bound', 'true');
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casa-tile-inquiry"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('[data-casa-inquiry]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var dialog = root.querySelector('[data-casa-inquiry-dialog]');
      var closeBtn = root.querySelector('[data-casa-inquiry-close]');
      var lastFocus = null;
      root.classList.add('is-enhanced');

      function panel(mode) {
        return root.querySelector('[data-casa-inquiry-panel="' + mode + '"]');
      }

      var pageOverflow = '';
      var bodyOverflow = '';

      function setPageScrollLocked(locked) {
        if (locked) {
          pageOverflow = document.documentElement.style.overflow;
          bodyOverflow = document.body.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
        } else {
          document.documentElement.style.overflow = pageOverflow;
          document.body.style.overflow = bodyOverflow;
        }
      }

      function openInquiry(mode) {
        lastFocus = document.activeElement;
        var quotePanel = panel('quote');
        var samplePanel = panel('sample');
        if (quotePanel) quotePanel.hidden = mode !== 'quote';
        if (samplePanel) samplePanel.hidden = mode !== 'sample';
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        else if (dialog) dialog.setAttribute('open', '');
        setPageScrollLocked(true);
        var focusEl = root.querySelector('[data-casa-inquiry-panel="' + mode + '"] input, [data-casa-inquiry-panel="' + mode + '"] select, [data-casa-inquiry-panel="' + mode + '"] textarea');
        if (focusEl) focusEl.focus();
      }

      function closeInquiry() {
        if (dialog && typeof dialog.close === 'function' && dialog.open) dialog.close();
        else if (dialog) dialog.removeAttribute('open');
        setPageScrollLocked(false);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      root.querySelectorAll('[data-casa-inquiry-open]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          openInquiry(trigger.getAttribute('data-casa-inquiry-open'));
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', closeInquiry);
      if (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeInquiry();
        });
        dialog.addEventListener('close', function () {
          setPageScrollLocked(false);
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        });
      }

      root.querySelectorAll('form.casa-tile-inquiry-form').forEach(function (formEl) {
        formEl.addEventListener('submit', function () {
          var body = formEl.querySelector('[name="contact[body]"]');
          if (!body) return;
          if (body.getAttribute('data-casa-inquiry-packed') === 'true') return;
          var valueFor = function (key) {
            var field = formEl.querySelector('[data-casa-inquiry-field="' + key + '"]');
            return field ? field.value : '';
          };
          var packed = [
            'Inquiry type: ' + valueFor('inquiry_type'),
            'Product title: ' + valueFor('product_title'),
            'Product handle: ' + valueFor('product_handle'),
            'Product URL: ' + valueFor('product_url'),
            'Selected variant: ' + valueFor('variant_title'),
            'Selected Size: ' + valueFor('size'),
            'Selected Finish: ' + valueFor('finish'),
            'Variant SKU: ' + valueFor('sku'),
            '',
            body.value || ''
          ].join('\n');
          body.value = packed;
          body.setAttribute('data-casa-inquiry-packed', 'true');
        });
      });

      root.querySelectorAll('.casa-tile-inquiry-form__success').forEach(function (el) {
        var wrap = el.closest('[data-casa-inquiry-panel]');
        if (wrap && wrap.getAttribute('data-casa-inquiry-panel')) {
          openInquiry(wrap.getAttribute('data-casa-inquiry-panel'));
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casa-washbasin-inquiry"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('[data-casa-washbasin-inquiry]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var dialog = root.querySelector('[data-casa-project-dialog]');
      var closeBtn = root.querySelector('[data-casa-project-close]');
      var lastFocus = null;
      var pageOverflow = '';
      var bodyOverflow = '';
      var postedSuccessVisible = !!root.querySelector('[data-casa-project-success]');
      var pendingFreshReset = false;
      root.classList.add('is-enhanced');

      function setPageScrollLocked(locked) {
        if (locked) {
          pageOverflow = document.documentElement.style.overflow;
          bodyOverflow = document.body.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
        } else {
          document.documentElement.style.overflow = pageOverflow;
          document.body.style.overflow = bodyOverflow;
        }
      }

      function stripContactPostedState() {
        try {
          var url = new URL(window.location.href);
          var changed = url.searchParams.has('contact_posted');
          url.searchParams.delete('contact_posted');
          var hash = url.hash || '';
          var hashId = hash.charAt(0) === '#' ? hash.slice(1) : hash;
          var isProjectFormHash = hashId.indexOf('CasaWashbasinForm-') === 0;
          root.querySelectorAll('form.casa-project-inquiry-form').forEach(function (formEl) {
            if (hashId && formEl.id && hashId === formEl.id) isProjectFormHash = true;
          });
          if (isProjectFormHash) {
            url.hash = '';
            changed = true;
          }
          if (changed) {
            history.replaceState(history.state, '', url.pathname + url.search);
          }
        } catch (err) {}
      }

      function showFreshFields(resetFields) {
        root.querySelectorAll('[data-casa-project-success]').forEach(function (el) {
          el.setAttribute('hidden', '');
        });
        root.querySelectorAll('[data-casa-project-fields]').forEach(function (el) {
          el.removeAttribute('hidden');
        });
        postedSuccessVisible = false;
        if (!resetFields) return;
        root.querySelectorAll('form.casa-project-inquiry-form').forEach(function (formEl) {
          formEl.reset();
          var body = formEl.elements['contact[body]'];
          if (body) body.removeAttribute('data-casa-project-packed');
        });
      }

      function visibleSuccess() {
        var successEl = root.querySelector('[data-casa-project-success]');
        if (!successEl || successEl.hasAttribute('hidden')) return null;
        return successEl;
      }

      function openInquiry(fromCta) {
        lastFocus = document.activeElement;
        if (fromCta && (visibleSuccess() || pendingFreshReset)) {
          showFreshFields(true);
          pendingFreshReset = false;
        }
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        else if (dialog) dialog.setAttribute('open', '');
        setPageScrollLocked(true);
        var successEl = visibleSuccess();
        if (successEl && typeof successEl.focus === 'function') {
          successEl.focus();
          return;
        }
        var fields = root.querySelector('[data-casa-project-fields]:not([hidden])');
        var focusEl = fields && fields.querySelector('input:not([type="hidden"]), select, textarea');
        if (focusEl) focusEl.focus();
      }

      function dismissSuccessState() {
        stripContactPostedState();
        if (visibleSuccess()) {
          pendingFreshReset = true;
          showFreshFields(false);
        }
      }

      function closeInquiry() {
        dismissSuccessState();
        if (dialog && typeof dialog.close === 'function' && dialog.open) dialog.close();
        else if (dialog) dialog.removeAttribute('open');
        setPageScrollLocked(false);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      document.querySelectorAll('[data-casa-project-open="' + dialog.id + '"]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          openInquiry(true);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', closeInquiry);
      if (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeInquiry();
        });
        dialog.addEventListener('close', function () {
          setPageScrollLocked(false);
          dismissSuccessState();
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        });
      }

      root.querySelectorAll('form.casa-project-inquiry-form').forEach(function (formEl) {
        formEl.addEventListener(
          'submit',
          function () {
            var body = formEl.elements['contact[body]'];
            if (body && body.getAttribute('data-casa-project-packed') !== 'true') {
              var valueFor = function (name) {
                var field = formEl.elements['contact[' + name + ']'];
                return field && field.value ? field.value : '';
              };
              var packed = [
                'Inquiry type: Washbasin project recommendation',
                'Source: Washbasins collection',
                'Preferred Series: ' + valueFor('preferred_series'),
                'Preferred Size: ' + valueFor('preferred_size'),
                'Color Direction (lead qualification): ' + valueFor('color_direction'),
                'Project Type: ' + valueFor('project_type'),
                'Country / Market: ' + valueFor('country'),
                'Space: ' + valueFor('space'),
                'Approx. Quantity: ' + valueFor('approx_quantity'),
                '',
                valueFor('body')
              ].join('\n');
              body.value = packed;
              body.setAttribute('data-casa-project-packed', 'true');
            }
            if (formEl.closest('dialog')) {
              document.body.appendChild(formEl);
            }
          },
          true
        );
      });

      if (postedSuccessVisible) openInquiry(false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casa-washbasin-pdp-inquiry"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('[data-casa-washbasin-pdp-inquiry]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var dialog = root.querySelector('[data-casa-project-dialog]');
      var closeBtn = root.querySelector('[data-casa-project-close]');
      var lastFocus = null;
      var pageOverflow = '';
      var bodyOverflow = '';
      var postedSuccessVisible = !!root.querySelector('[data-casa-project-success]');
      var pendingFreshReset = false;
      root.classList.add('is-enhanced');
      var sticky = root.querySelector('[data-casa-sticky-quote]');
      var inFlowCta = root.querySelector('.casa-washbasin-pdp-inquiry__cta');
      var mobileQuery = window.matchMedia('(max-width: 899px)');

      var inFlowVisible = true;
      var pauseVisible = false;

      function setStickyVisible(visible) {
        if (!sticky) return;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }

      function refreshSticky() {
        if (!sticky || !mobileQuery) {
          return;
        }
        if (!mobileQuery.matches || pauseVisible) {
          setStickyVisible(false);
          return;
        }
        setStickyVisible(!inFlowVisible);
      }

      function setDialogOpen(open) {
        root.classList.toggle('is-dialog-open', open);
      }

      if (sticky && inFlowCta && typeof IntersectionObserver === 'function') {
        var observer = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            inFlowVisible = !!(entry && entry.isIntersecting);
            refreshSticky();
          },
          { threshold: 0, rootMargin: '0px' }
        );
        observer.observe(inFlowCta);
        var pauseIds = {};
        var pauseObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var key = entry.target.id || entry.target.className;
              if (entry.isIntersecting) pauseIds[key] = true;
              else delete pauseIds[key];
            });
            pauseVisible = Object.keys(pauseIds).length > 0;
            refreshSticky();
          },
          { threshold: 0.12, rootMargin: '0px' }
        );
        document.querySelectorAll('[data-casa-sticky-pause]').forEach(function (pauseEl) {
          pauseObserver.observe(pauseEl);
        });
        if (typeof mobileQuery.addEventListener === 'function') {
          mobileQuery.addEventListener('change', refreshSticky);
        }
      }

      function setPageScrollLocked(locked) {
        if (locked) {
          pageOverflow = document.documentElement.style.overflow;
          bodyOverflow = document.body.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
        } else {
          document.documentElement.style.overflow = pageOverflow;
          document.body.style.overflow = bodyOverflow;
        }
      }

      function stripContactPostedState() {
        try {
          var url = new URL(window.location.href);
          var changed = url.searchParams.has('contact_posted');
          url.searchParams.delete('contact_posted');
          var hash = url.hash || '';
          var hashId = hash.charAt(0) === '#' ? hash.slice(1) : hash;
          var isFormHash = hashId.indexOf('CasaWashbasinPdpForm-') === 0;
          root.querySelectorAll('form.casa-washbasin-pdp-inquiry-form').forEach(function (formEl) {
            if (hashId && formEl.id && hashId === formEl.id) isFormHash = true;
          });
          if (isFormHash) {
            url.hash = '';
            changed = true;
          }
          if (changed) {
            history.replaceState(history.state, '', url.pathname + url.search);
          }
        } catch (err) {}
      }

      function showFreshFields(resetFields) {
        root.querySelectorAll('[data-casa-project-success]').forEach(function (el) {
          el.setAttribute('hidden', '');
        });
        root.querySelectorAll('[data-casa-project-fields]').forEach(function (el) {
          el.removeAttribute('hidden');
        });
        postedSuccessVisible = false;
        if (!resetFields) return;
        root.querySelectorAll('form.casa-washbasin-pdp-inquiry-form').forEach(function (formEl) {
          formEl.reset();
          var body = formEl.elements['contact[body]'];
          if (body) body.removeAttribute('data-casa-project-packed');
        });
      }

      function visibleSuccess() {
        var successEl = root.querySelector('[data-casa-project-success]');
        if (!successEl || successEl.hasAttribute('hidden')) return null;
        return successEl;
      }

      function openInquiry(fromCta) {
        lastFocus = document.activeElement;
        if (fromCta && (visibleSuccess() || pendingFreshReset)) {
          showFreshFields(true);
          pendingFreshReset = false;
        }
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        else if (dialog) dialog.setAttribute('open', '');
        setDialogOpen(true);
        setPageScrollLocked(true);
        var successEl = visibleSuccess();
        if (successEl && typeof successEl.focus === 'function') {
          successEl.focus();
          return;
        }
        var fields = root.querySelector('[data-casa-project-fields]:not([hidden])');
        var focusEl = fields && fields.querySelector('input:not([type="hidden"]):not([type="checkbox"]), select, textarea');
        if (focusEl) focusEl.focus();
      }

      function dismissSuccessState() {
        stripContactPostedState();
        if (visibleSuccess()) {
          pendingFreshReset = true;
          showFreshFields(false);
        }
      }

      function closeInquiry() {
        dismissSuccessState();
        setDialogOpen(false);
        if (dialog && typeof dialog.close === 'function' && dialog.open) dialog.close();
        else if (dialog) dialog.removeAttribute('open');
        setPageScrollLocked(false);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      function applyAlsoNeedPreselect(trigger) {
        var preselect = trigger.getAttribute('data-casa-also-need-preselect');
        if (!preselect) return;
        var names = preselect.split(',');
        root.querySelectorAll('form.casa-washbasin-pdp-inquiry-form').forEach(function (formEl) {
          names.forEach(function (name) {
            var field = formEl.elements['contact[' + name.trim() + ']'];
            if (field && field.type === 'checkbox') field.checked = true;
          });
        });
      }

      document.querySelectorAll('[data-casa-project-open="' + dialog.id + '"]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          openInquiry(true);
          applyAlsoNeedPreselect(trigger);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', closeInquiry);
      if (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeInquiry();
        });
        dialog.addEventListener('close', function () {
          setDialogOpen(false);
          setPageScrollLocked(false);
          dismissSuccessState();
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        });
      }

      root.querySelectorAll('form.casa-washbasin-pdp-inquiry-form').forEach(function (formEl) {
        formEl.addEventListener(
          'submit',
          function () {
            var body = formEl.elements['contact[body]'];
            if (body && body.getAttribute('data-casa-project-packed') !== 'true') {
              var valueFor = function (name) {
                var field = formEl.elements['contact[' + name + ']'];
                return field && field.value ? field.value : '';
              };
              var alsoNeed = [];
              formEl.querySelectorAll('[data-casa-also-need]:checked').forEach(function (box) {
                alsoNeed.push(box.value);
              });
              var packed = [
                'Inquiry type: Washbasin quote',
                'Source: Washbasin PDP',
                'Product: ' + valueFor('product_title'),
                'Handle: ' + valueFor('product_handle'),
                'URL: ' + valueFor('product_url'),
                'Selected variant: ' + valueFor('variant_title'),
                'Selected Size: ' + valueFor('size'),
                'Variant ID: ' + valueFor('variant_id'),
                'Project Type: ' + valueFor('project_type'),
                'Country / Market: ' + valueFor('country'),
                'Quantity: ' + valueFor('approx_quantity'),
                'Required Date: ' + valueFor('required_date'),
                'I also need: ' + (alsoNeed.length ? alsoNeed.join(', ') : ''),
                '',
                valueFor('body')
              ].join('\n');
              body.value = packed;
              body.setAttribute('data-casa-project-packed', 'true');
            }
            if (formEl.closest('dialog')) {
              document.body.appendChild(formEl);
            }
          },
          true
        );
      });

      if (postedSuccessVisible) openInquiry(false);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
